<template>
    <div class="" >
        <div class="justify-content-between">
            <div v-if="object">
                <h3>{{object.name}}  Нэмэх</h3>
                <p>Нэмэх мэдээллээ мөр мөрөөр бичиж оруулаад хадгалах товч дарна уу</p>
                <p class="text-danger">Жишээ :</p>
                <p class="text-danger">infoname1 <br/>infoname2</p>
            </div>
            <div >
              
                <div class="form-group">
                    <textarea rows="3" v-model.trim="teachersText" class="form-control" placeholder="мэдээлэл"/>
                </div>
            
                <button type="button" class="btn btn-primary" @click="addTeachers">
                    нэмэх
                </button>
                <hr>
              
            </div>
        
        </div>
        <div class="card shadow my-4" v-if="tmpTeachers!=undefined && tmpTeachers!=null && tmpTeachers.length>0">
            <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">жагсаалт</h6>
            </div>
            <div class="card-body">
                <div class="table-responsive" >
                    <button class="btn btn-danger" @click="_saveAll">Бүгдийг хадгалах</button>
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                    <tr>
                        <th>№</th>
                        <th>Нэр</th>
                        <th>Үйлдэл</th>
                    </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(teacher, index) in tmpTeachers" >
                            <td>{{index+1}}</td>
                            <td>{{teacher.name}}</td>
                            <td>
                                <button class="btn btn-danger" @click="_save(teacher, index, true)">Хадгалах</button>
                            </td>
                        </tr>
                    
                    </tbody>
                </table>
                </div>
            </div>
        </div>

    </div>
    
</template>

<script>
    import { mapState } from 'vuex'
    import moment,{ unix } from 'moment'
    const fb = require('../../firebaseConfig.js')

    export default {
        data() {
            return {
               object:null,
               teachersText:null,
               tmpTeachers:[]

            }
        },
        props: {
            path: { 
                required: true,
            },
            parentPath:{
                required:false
            },
            setcount:{
                required:false
            }
        },
        computed: {
            ...mapState(['userProfile', 'currentUser'])
        },
        methods: {
            _getData(){
                if(this.parentPath!=null && this.parentPath!=undefined && this.parentPath!=''){
                    fb.db.doc(this.parentPath).get().then(objectDoc=>{
                        this.object=objectDoc.data();
                    });
                }
            },
            addTeachers(){
                if(this.teachersText!=null && this.teachersText!=''){
                    //TODO
                    var arrayOfLines = this.teachersText.match(/[^\r\n]+/g);
                    // var arrayOfLines= this.teachersText.split("\n");
                    arrayOfLines.forEach(value=>{
                        var lineArray=value;

                        // if(lineArray!=null && lineArray.length==1 && lineArray[0]!=null && lineArray[0]!=''){

                            var tmp={
                                "name": lineArray
                            }
                            this.tmpTeachers.push(tmp);

                        // }
                    });
                    this.teachersText=''
                    }
            },
            async _save(data, index, splice) {
      
                if(data!=null && data!=undefined && this.path!=null && this.path!=undefined){
                    this.loading=true;
                    var tmpMark = Object.assign({}, data);
                    tmpMark.createdAt=new Date();
                    var markRef=fb.db.collection(this.path).doc();
                    await markRef.set(tmpMark);
                    
                    this.loading=false;
                }
                if(splice==true)
                    this.tmpTeachers.splice(index,1);
                if(this.setcount==true){
                    var result=await fb.db.collection(this.path).get();
                    if(result!=null)
                        fb.db.doc(this.parentPath).update({"numberOfChildren":result.size });
                }

            },
            async _saveAll() {
                
                if(this.tmpTeachers!=null && this.tmpTeachers.length>0){
                    var r = confirm("Бүгдийг хадгалах уу. Та хадгалагдаж дуустал вэбээс гаралгүй хүлээнэ үү");
                    if (r == true) {
                        var i=0;
                        for(const value of this.tmpTeachers){
                            await this._save(value, i,false);
                            i++;
                        }
                        this.tmpTeachers=[];
                        alert("Амжилттай хадгаллаа");
                    } 
                }

            },

        },
        created() {
            this._getData();
                
        },

        filters: {
            formatDate(val) {
                if (!val) { return '-' }
                let date = val.toDate()
                return moment(date).format('MM/DD/YYYY HH:mm');
            },
            trimLength(val) {
                if (val.length < 200) { return val }
                return `${val.substring(0, 200)}...`
            }
        }
    }
</script>
